import React, { useState, useEffect, MouseEvent, ChangeEvent } from "react";
import AppState from "./types/AppState";
import AppProps from "./types/AppProps";
import LandingPage from "./Views/LandingPage";
import Questions from "./Views/Questions";
import Checklist from "./Views/Checklist";

import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

declare global {
  interface Window {
    csrfTokenValue: any;
    dataLayer: any;
  }
}

export default ({ data }: AppProps) => {
  const [appState, setAppState] = useState<AppState>({
    start: "", // 1a
    transfer: "", // 1b
    undergraduatePrograms: [], // 2a
    graduatePrograms: [], // 2b
    citizenship: "", // 3a
    indigenous: "", // 3a2
    language: "", // 3b
    location: "", // 4
    applying: [], // 5
    finances: [], // 6
    next: "",
  });

  return (
    <Router>
      <Switch>
        <Route path="/checklist">
          <Checklist
            appState={appState}
            setAppState={setAppState}
            data={data}
          />
        </Route>
        <Route path="/:question?">
          <Questions
            appState={appState}
            setAppState={setAppState}
            data={data}
          />
        </Route>
      </Switch>
    </Router>
  );
};
